import { always } from "../../../base/utils/ramdaEquivalents.utils";
import { makeObservableRouteDef } from "../../../base/utils/routes.utils";
import ModuleNotifications from "./Notifications.module";

export const NotificationsModuleRouteDef = makeObservableRouteDef({
  identifier: 'notifications',
  urlFactory: always('notifications'),
  composeTitle: always('notifications'),
  component: ModuleNotifications
})